import styled from 'styled-components';

export const Wrapper = styled.div`
	display: grid;
	gap: 1.25rem;

	.page-header {
		grid-area: header;
	}
	.a1 {
		grid-area: a1;
	}
	.a2 {
		grid-area: a2;
	}

	grid-template-areas:
		'header'
		'a1'
		'a2';
`;

export const IframeWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
	height: 100%;

	iframe {
		flex: 1 1 0;
		min-height: 0;
	}
`;
